<template>
    <div>
        <BACK title="新增物件買賣" name='Home'/>
        <el-form ref="form" :model="form" :rules="rules">
            <el-form-item label="買賣種類" prop="interviewType">
                <div class="clear">
                    <el-checkbox v-for="({id, name},idx) in sellType" v-model="interviewOption[idx]" :key="idx"
                                 @change="chengeJobType(idx)">{{name}}
                    </el-checkbox>
                </div>
            </el-form-item>
            <el-form-item label="選擇地區" prop="areaId">
                <div class="clear">
                    <el-select class="select_area" popper-class="select_area_popper" v-model="form.areaId"
                               placeholder="請選擇">
                        <el-option v-for="({areaId, areaName},idx) in searchAreaData" :label="areaName" :value="areaId"
                                   :key="idx"/>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item label="金額" prop="amount" >
                <div class="input_notes">未入金額則為面議</div>
                <div class="flex">
                    <el-input v-model="form.amount" type="number" clearable placeholder="輸入金額" oninput="if(value.length>5)value=value.slice(0,8)"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="聯絡姓名" prop="contactName">
                <el-input v-model="form.contactName" type="text" maxlength="30" clearable
                          placeholder="請輸入聯絡人名稱"></el-input>
            </el-form-item>
            <el-form-item label="聯絡資訊" prop="contactMemo">
                <el-input v-model="form.contactMemo" type="text" maxlength="30" clearable
                          placeholder="請輸入聯絡資訊"></el-input>
            </el-form-item>
            <el-form-item label="刊登標題" prop="title">
                <el-input v-model="form.title" type="text" maxlength="30" clearable placeholder="輸入標題"></el-input>
            </el-form-item>
            <el-form-item label="內容敘述" prop="content">
                <el-input v-model="form.content" maxlength="1000" type="textarea" :autosize="{ minRows: 5}"></el-input>
            </el-form-item>
            <el-form-item label="上傳圖片(點選圖片可操作刪除)">
                <el-upload
                    class="avatar-uploader"
                    ref="upload"
                    action="#"
                    :file-list="fileList"
                    :on-change="beforeAvatarUpload"
                    :before-upload="test"
                    :auto-upload="false"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    :limit="imgLimit"
                    :on-exceed="handleExceed"
                    accept="image/jpeg,image/jpg,image/png"
                    list-type="picture">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                    <p class="avatar-uploader-text">選擇檔案</p>
                </el-upload>
            </el-form-item>
        </el-form>
        <div class="note">*文章均遵守<span class="tag" @click="openTerms">《服務條款》</span></div>
        <div class="btn">
            <el-button type="success" :disabled="loading" @click="handleSubmit"><i class="el-icon-loading"
                                                                                   v-if="loading"></i>送出
            </el-button>
        </div>
        <DialogTerms :visbileName="'dialogTermsVisible'"/>
    </div>
</template>
<script>
    import BACK from '@/components/back.vue'
    import FN from '@/components/fn'
    import DialogTerms from '@/components/DialogTerms'
    import {mapActions, mapGetters} from 'vuex'
    import {getStorage} from '@/util'
    import axios from 'axios'

    export default {
        name: 'add',
        components: {
            BACK,
            DialogTerms
        },
        mixins: [FN],
        data() {
            return {
                fileList: [],
                imagesList: [],
                imgLimit: 10,
                interviewOption: {
                    0: false,
                    1: false
                },
                form: {
                    title: '',
                    areaId: 1,
                    amount: '',
                    saleType: '',
                    content: '',
                    images: [],
                    contactName: '',
                    contactMemo: ''
                }
            }
        },
        computed: {
            ...mapGetters([
                'sellType',
                'searchArea'
            ]),
            searchAreaData() {
                const fake = [
                    {
                        areaId: 1,
                        areaName: "不限"
                    }
                ]
                if (!this.searchArea?.length) {
                    return fake
                }
                return this.searchArea
            },
            rules() {
                const message = '輸入不完整'
                // 自訂驗證-interviewType
                const isSellType = (rule, value, callback) => {
                    if (!this.interviewOption[0] && !this.interviewOption[1]) {
                        callback(new Error('請選擇買賣種類'))
                    } else {
                        callback()
                    }
                }
                return {
                    interviewType: [
                        {required: true, trigger: 'change', validator: isSellType}
                    ],
                    areaId: [{required: true, trigger: 'change', message}],
                    title: [{required: true, trigger: 'change', message: "請輸入刊登標題"}],
                    content: [{required: true, trigger: 'change', message: "請輸入內容敘述"}],
                    contactName: [{required: true, trigger: 'change', message: '請輸入聯絡姓名'}],
                    contactMemo: [{required: true, trigger: 'change', message: '請輸入聯絡資訊'}]
                }
            }
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            test() {
                console.log('asdasdasd');
            },
            chengeJobType(idx) {
                if (this.interviewOption[idx]) {
                    this.interviewOption[Math.abs(idx - 1)] = false
                    this.form.saleType = +this.sellType[idx].id
                }
            },
            beforeFormSubmit() {
                this.imagesList.forEach(({imageId}) => {
                    this.form.images.push(imageId)
                });
            },
            //送出表單
            handleSubmit() {
                const form = this.$refs.form
                this.beforeValidate()
                //console.log(this.fileList)
                this.clearSearchData()
                form.validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.beforeFormSubmit()
                        this.FETCH({
                            key: 'SELL_ADD',
                            ...this.form
                        }).then((res) => {
                            //需要accToken的驗證
                            if (+(res || {}).code === -3) {
                                this.checkNewToken(this.handleSubmit)
                            } else {
                                this.handleResponse(res)
                            }
                        })
                    } else {
                        this.loading = false
                        this.handleUnValid()
                    }
                })
            },
            //回應
            handleResponse(res) {
                if (!+res.code) {
                    this.$confirm('恭喜您獲得1次抽獎機會!!',{
                        title:"文章已新增",
                        confirmButtonText: '前往抽獎',
                        cancelButtonText: '回列表',
                        type: 'success',
                        closeOnClickModal: false
                    }).then(() => {
                        this.$router.replace({name: 'Lottery'})
                    }).catch(() => {
                        this.$router.replace({name: 'Sell', params: {tag: 'my'}})
                        this.$parent.handleSearch()
                    });
                } else {
                    this.$confirm(res.message, {
                        showCancelButton: false,
                        type: 'error'
                    })
                }
                this.loading = false
            },
            getDetail() {
                const id = this.$route.params.id
                this.FETCH({
                    key: 'SELL_DETAIL',
                    id: id
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getDetail)
                    }
                })
            },
            openTerms() {
                this.$parent.dialogVisible = true
            },
            handleBack() {
                this.$router.replace({name: 'Sell'})
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`確定移除 ${file.name}？`);
            },
            handleRemove(file, fileList) {
                const fileUid = file.uid
                // for(var t = Date.now();Date.now() - t <= 5000;);
                this.imagesList = this.imagesList.filter(({uid}) => uid !== fileUid)
                //console.log(file, this.imagesList,'移除');
            },
            beforeAvatarUpload(file, fileList) {
                this.loading = true;
                // console.log(fileList);
                // const isPNG = file.raw.type === 'image/png';
                // const isJPG = file.raw.type === 'image/jpeg';
                // const isSVG = file.raw.type === 'image/svg+xml';
                // const isLt2M = file.raw.size / 1024 / 1024 < 3;
                // if (!(isJPG || isPNG || isSVG)) {
                //   this.$message.error('圖片只允許JPG/PNG/SVG 格式!');
                //   this.$nextTick(()=>{
                //     this.handleRemove(file,fileList);
                //     this.$refs.upload.abort(file);
                //   })
                //
                //
                //   return true
                // }
                // if (!isLt2M) {
                //   this.$message.error('圖片3MB!');
                //   this.handleRemove(file,fileList)
                //   return true
                // }
                // if((isJPG || isPNG || isSVG)){
                this.handleUpload(file.raw)
                // }
            },
            handleExceed() {
                this.$message.error(`最多上傳${this.imgLimit}張圖片!`);
            },
            handleUpload(file) {
                //console.log(file,'file')
                const isLogin = getStorage('assessToken')
                axios.defaults.headers.common['Authorization'] = isLogin
                const form = new FormData()
                form.append('image', file)
                // 上傳到後端伺服器
                axios.post('/api/file/image/upload', form).then((res) => {
                    const code = res?.data?.code
                    //需要accToken的驗證
                    if (+code === -3) {
                        const token = getStorage('refreshToken')
                        this.FETCH({
                            key: 'LOGIN_STATE',
                            refreshToken: token
                        }).then((res) => {
                            if (!+(res || {}).code) {
                                this.handleToken((res || {}).data)
                                this.handleUpload(file)
                            } else {
                                this.$confirm('登入逾時', {
                                    showCancelButton: false,
                                    type: 'error'
                                })
                                    .then(() => {
                                        location.href = '/app/'
                                    })
                            }
                        })
                    }
                    //上傳成功
                    if (!+code) {
                        const data = res.data.data
                        this.imagesList.push({
                            uid: file.uid,
                            imageId: data.imageId,
                            name: file.name,
                            fileName: data.fileName
                        })
                        //console.log(this.imagesList,'上傳');
                    }
                    this.loading = false;
                })

            },
            //清除搜尋資料
            clearSearchData() {
                this.$parent.qkArea = ''
                this.$parent.form.area = []
                this.$parent.form.amountFrom = ''
                this.$parent.form.amountTo = ''
                this.$parent.form.orderByCreateAt = ''
                this.$parent.form.saleType = ''
            },
            getMemberInfo() {
                this.FETCH({
                    key: 'USER_INFO',
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.handleSubmit)
                    } else {
                        if (!+res.code) {
                            this.form.contactName = res.data.nickname;
                            this.form.contactMemo = '電話-' + res.data.phone;
                        }
                    }
                })
            }
        },
        mounted() {
            this.getMemberInfo()
        }
    }
</script>
